import React, { useMemo } from 'react';
import useThemeAccent from './use-theme-accent';
import { CUSTOM_LOGO } from '../constants';
import { Watermark } from '../components/watermark';
const useWatermark = ({ provider, customLogo, cdnUrl }) => {
    const themeAccent = useThemeAccent();
    const watermark = useMemo(() => {
        if (customLogo) {
            return customLogo;
        }
        // provider can be set to 'custom' for readability reason only
        // the only way to get custom logo is to pass it as a prop (customLogo)
        if (!provider || !themeAccent || provider === CUSTOM_LOGO || !cdnUrl) {
            return () => null;
        }
        const imageUrl = `${cdnUrl}/${provider.toLowerCase()}/watermark-${themeAccent}.svg`;
        return () => React.createElement(Watermark, { imageUrl: imageUrl, provider: provider });
    }, [provider, themeAccent, customLogo, cdnUrl]);
    return {
        Watermark: watermark,
        themeAccent
    };
};
export default useWatermark;
